import { Flex, Link, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

// TODO: the API doesn't expose a per-account Stripe Express URL yet, so link to the generic
// dashboard. Swap for the account-specific link once it's available.
const STRIPE_DASHBOARD_URL = 'https://dashboard.stripe.com/'

interface ManageStripeAccountSectionProps {
  isConnected: boolean
}

export const ManageStripeAccountSection = ({ isConnected }: ManageStripeAccountSectionProps): ReactElement => {
  const { t } = useTranslation()

  const title = isConnected
    ? t('settings.organization.card_payments.configuration.manage.title')
    : t('settings.organization.card_payments.configuration.manage.disconnected.title')
  const description = isConnected
    ? t('settings.organization.card_payments.configuration.manage.description')
    : t('settings.organization.card_payments.configuration.manage.disconnected.description')

  return (
    <Flex alignItems="flex-start" flexDirection="column" gap={Spacing.S8}>
      <Text variant="bodyLG" weight="medium">
        {title}
      </Text>
      <Text colorVariant="secondary">{description}</Text>
      <Link href={STRIPE_DASHBOARD_URL} rel="noopener noreferrer" target="_blank">
        {t('settings.organization.card_payments.configuration.manage.dashboard_link')}
      </Link>
    </Flex>
  )
}
